import React from 'react'
// @src imports
import { Button } from 'src/chrome'
import { ColorFragment } from 'src/graphql'
// relative imports
import ColorPicker from '../ColorPicker/ColorPicker'

import styles from './backgroundPicker.module.scss'
import { Api } from '../../api'
import { Steps } from '../../types'

type Props = {
  api: Api & { step: { type: Steps.EditBackgroundColor } }
}

const BackgroundPicker: React.FC<Props> = props => {
  const {
    step,
    card,
    selectedFullBleed,
    getSelectedPanel,
    editBackgroundPicture,
    updatePanel,
    removeBackgroundPicture,
  } = props.api
  const { fullBleedIndex, panelIndex } = step

  const backgroundElement = selectedFullBleed?.backgroundElement

  const setBackgroundColor = (color: ColorFragment) =>
    updatePanel(fullBleedIndex, panelIndex, panel => ({
      ...panel,
      backgroundColor: color,
    }))

  return (
    <div className={styles.componentContainer}>
      <ColorPicker
        selectedColor={getSelectedPanel(step)?.backgroundColor ?? undefined}
        selectColor={setBackgroundColor}
        removeColor={() => setBackgroundColor({ red: 0, green: 0, blue: 0 })}
      />
      {/*TODO: fix the image span on three panel then remove it from the conditional below when it works*/}
      {backgroundElement &&
        card.type !== 'THREE_PANEL' &&
        (!card.detailedSendableCard ||
          (card.detailedSendableCard &&
            !card.detailedSendableCard.insideRightImage)) && (
          <div>
            <h5 className={styles.sectionHeader}>Background Image</h5>
            <div className={styles.backgroundImageActions}>
              <Button
                id={'add_image_btn'}
                title={
                  backgroundElement.image && backgroundElement.image.image
                    ? 'Change Image'
                    : 'Add Image'
                }
                className={styles.spanningAction}
                onClick={() => editBackgroundPicture(fullBleedIndex, 'own')}
              />
              {backgroundElement.image && backgroundElement.image.image && (
                <Button
                  title={'Remove'}
                  className={styles.spanningAction}
                  onClick={() => removeBackgroundPicture(fullBleedIndex)}
                />
              )}
            </div>
          </div>
        )}
    </div>
  )
}

export default BackgroundPicker
